import { NSARouterMakerResult } from "namirasoft-account-react";
import { RoleInputRow, RoleRow } from "namirasoft-access";
import { AccessLayout } from "../AccessLayout";
import { AccessEntities } from "../AccessEntities";
import { AccessProps } from "../AccessProps";

interface RolePageProps extends NSARouterMakerResult, AccessProps { }

function RoleListPage(props: RolePageProps)
{
	return (
		<AccessLayout<RoleRow, RoleInputRow> {...props}
			action={{
				title: "",
				description: "A list of specific roles to be assigned to users for streamlined permission management.",
				menus: {}
			}}
			pages={{
				entity: AccessEntities.role(props),
				list: {
					ui: {}
				}
			}}
		>
			<></>
		</AccessLayout>
	);
}

export default RoleListPage;